import { RouterModule } from '@angular/router';

import { AuthenticatedGuard } from '../shared/authenticated.guard';
import { NewRegisterUserGuard } from '../shared/newRegisterUser.guard';
import { MfaLoginGuard } from 'app/shared/mfaLogin.guard';
import { AuthStateGuard } from 'app/shared/authState.guard';

import { NotFoundComponent } from '../shared/components/not-found/not-found.component';
import { AuthenticationContainerComponent } from '../authentication/containers/authentication-container/authentication-container.component';
import { UpdatePasswordContainerComponent } from '../authentication/containers/update-password-container/update-password-container.component';
import { StageContainerComponent } from '../stage/containers/stage-container/stage-container.component';
import { ErrorContainerComponent } from '../shared/containers/error-container/error-container.component';
import { DashboardContainerComponent } from '../shared/containers/dashboard-container/dashboard-container.component';
import { MfaauthenticationContainerComponent } from '../authentication/containers/mfaauthentication-container/mfaauthentication-container.component';

export const routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full', canActivate: [AuthenticatedGuard, NewRegisterUserGuard, AuthStateGuard] },
    { path: 'authentication', component: AuthenticationContainerComponent },
    { path: 'authentication/updatePassword', component: UpdatePasswordContainerComponent, canActivate: [AuthenticatedGuard] },
    { path: 'authentication/mfaAuthentication', component: MfaauthenticationContainerComponent, canActivate: [MfaLoginGuard] },
    { path: 'stage/:type/:typeid/task/:taskid', component: StageContainerComponent, canActivate: [AuthenticatedGuard, NewRegisterUserGuard, AuthStateGuard] },
    { path: 'stage/:type/:typeid', component: StageContainerComponent, canActivate: [AuthenticatedGuard, NewRegisterUserGuard, AuthStateGuard] },
    { path: 'dashboard', component: DashboardContainerComponent, canActivate: [AuthenticatedGuard, NewRegisterUserGuard, AuthStateGuard]  },
    { path: 'error', component: ErrorContainerComponent },
    {
        path: '**',
        component: NotFoundComponent
    }
];

export const routing = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/application/app.routes.ts